// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"588":"cbdeefb5","612":"118cc364","625":"252bb9b6","996":"98c7febc"}[chunkId] + ".css";
};